import * as rutHelpers from 'rut-helpers';

const capitalize = ((value) => {
  if (!value) return ''
  return value
    .toLowerCase()
    .split(' ')
    .map(w => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ')
})

const rutFilter = ((value) => {
  return rutHelpers.rutFormat(value)
})

const rutValidate = ((value) => {
  return rutHelpers.rutValidate(value)
})

const rutClean = ((value) => {
  return rutHelpers.rutClean(value)
})

export const utils = {
  capitalize,
  rutFilter,
  rutValidate,
  rutClean
}
